import React, { Component, PropTypes } from 'react';
import { Styles, IconButton } from 'material-ui';
import ClassNames from 'classnames';
import { GridContainer, GridRow, GridCell } from 'components/Grid/Grid';
import { pageModules } from 'Constants';
import * as Icons from 'components/Icons';
import * as Colors from 'components/Material/Styles/Colors';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as PageModules from 'plugins/PageModules';

const { Spacing } = Styles;

const styles = {
  icon: {
    backgroundColor: Colors.Colors.darkBondiBlue,
    width: Spacing.desktopKeylineIncrement * 0.75,
    height: Spacing.desktopKeylineIncrement * 0.75,
    padding: 0,
    margin: 0
  },
  container: {
    backgroundColor: Colors.Colors.darkBondiBlue,
    // width : Spacing.desktopKeylineIncrement*2-Spacing.desktopGutterMini*2,
    // height : Spacing.desktopKeylineIncrement*2-Spacing.desktopGutterMini*4,
    margin: Spacing.desktopGutterMini,
    color: Colors.Colors.fullWhite,
    fontSize: '18px',
    textAlign: 'center',
    fontWeight: 100,
    cursor: 'pointer'
  }
};


export default class ModuleMenu extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    onCreate: PropTypes.func.isRequired,
    onClose: PropTypes.func
  };

  _onTouchTap(type) {
    this.props.onCreate(type);
  }

  render() {
    let modules = [];
    for (const moduleName in pageModules) {
      let moduleDetails = pageModules[moduleName];
      let Icon;
      let icon;
      let readable;
      let active = true;
      if (moduleDetails.plugin) {
        if (!moduleDetails.active || (!moduleDetails.public && !__DEV__)) {
          active = false;
        }
        const Mod = PageModules[moduleName.charAt(0).toUpperCase() + moduleName.slice(1) ];
        Icon = MaterialIcons[Mod.icon];
        readable = Mod.name;
        const size = Spacing.desktopKeylineIncrement * 0.75;
        icon = (
          <Icon
            style={{ width: size, height: size }}
            color={Colors.Colors.fullWhite}
          />
        );
      } else {
        Icon = Icons[moduleDetails.icon];
        icon = <Icon size={Spacing.desktopKeylineIncrement * 0.75} />;
        readable = this.context.getIntlMessage('pageModule.' + moduleName);
      }
      if (active) {
        modules.push(
          <GridCell size={6} key={moduleName}>
            <div
              style={styles.container}
              onTouchTap={this._onTouchTap.bind(this, moduleDetails.id)}
            >
              {icon}
              <div>{readable}</div>
            </div>
          </GridCell>
        );
      }
    }
    return (
      <GridContainer
        className={ClassNames('module-menu', this.props.className)}
        fluid={true}
      >
        {this.props.children}
        {modules}
      </GridContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ModuleMenu.js